fieldset
  label Von
  select(name="source").select-plain.pure-input-1
    each source in collection.models
      option(value=source.id, selected=model.sourceId === source.id) #{source.name}
